// Facade de la pantalla Clientes del Admin VL. Sin adapter mock: pega al silo real.
import { customersBackofficeClient } from './backoffice.client';

export const customersBackofficeApi = customersBackofficeClient;

export type {
    BackofficeCustomerDetail,
    BackofficeCustomerPurchase,
    BackofficeCustomerPurchasesPage,
    BackofficeCustomerRow,
    BackofficeCustomersResponse,
    CustomersBackofficeApi,
    ListCustomersOptions,
    PaymentKind,
    ProductCategory,
    PurchaseLine,
} from './contract';
